import app.cash.sqldelight.async.coroutines.awaitCreate
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.driver.worker.WebWorkerDriver
import com.kinoshazam.shared.data.db.sqldelight.KinoshkaDb
import org.w3c.dom.Worker

/**
 * SQLDelight + sql.js in a Web Worker.
 * Default sql.js worker is in-memory for the page session; after login,
 * FavoriteInteractor.syncFavorites() repopulates from the API.
 */
actual class DatabaseDriverFactory {
    actual suspend fun createDriver(): SqlDriver? {
        val worker = Worker(
            js("""new URL("@cashapp/sqldelight-sqljs-worker/sqljs.worker.js", import.meta.url)""")
        )
        return WebWorkerDriver(worker).also { driver ->
            KinoshkaDb.Schema.awaitCreate(driver)
        }
    }
}
